<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="月度计划名称">
              <global-select
                @change="(val)=>{queryParams.monthPlanVersion=undefined}"
                :value.sync="queryParams.monthPlanName"
                selectType="selectSearch"
                requestApi="/scp/sopMonthPlan/monthPlanNamePullDown"
                :selectItem="{ value: 'label', label: 'label' }"
                searchParam="name"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                :value.sync="queryParams.monthPlanVersion"
                :setParams="{ monthPlanName: queryParams.monthPlanName }"
                selectType="selectSearch"
                requestApi="/scp/sopMonthPlan/monthPlanVersionPullDown"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="version"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工艺大类">
              <global-select
                :max-tag-count="1"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.productBroadCategoryList"
                selectType="selectMultiple"
                :selectData="productBroadCategoryOpinions"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="一件代发">
                <a-switch :checked="queryParams.isRetailFlag === 'Y'" @change="statusOnChange" />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="供应类型">
                <a-select :max-tag-count="1" show-search mode="multiple" :filter-option="filterOption" option-filter-prop="children" v-model="queryParams.supplyTypeList" >
                  <a-select-option v-for="(item) in supplyTypeOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="物料编码">
                <global-select
                  :assembleLabel="false"
                  :value.sync="queryParams.itemIdList"
                  selectType="selectSearch"
                  requestApi="/mes/mesDiscreteJobs/assemblyBox"
                  :selectItem="{ value: 'realValue', label: 'selectedValue' }"
                  searchParam="itemCode" />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleExport" type="primary" v-hasPermi="['scp:sopMpProductionDemand:exportOverall']">导出明细</a-button>
      <a-button @click="handleExportDetail" type="primary" v-hasPermi="['scp:sopMonthPlan:saveAndCalculate']">导出汇总</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-spin :spinning="isLoading">
          <ls-api-table
            ref="dataTable"
            :columns="columns"
            :tableProps="tableProps"
            rowKey="id"
            :scroll="{ fixScreen: true, x: 1300 }"
          >
            <template slot="isRetailFlag" slot-scope="{ record }">
              <span>{{ record.isRetailFlag==='Y'?'是':'否' }}</span>
            </template>
            <template slot="month" slot-scope="{ record, column }">
              <span v-if="!isEdit || currentId !== record.id">{{ record[column.dataIndex].productionDemand }}</span>
              <a-input-number
                v-if="isEdit && currentId === record.id"
                v-model="record[column.dataIndex].productionDemand"
                size="small"
              />
            <!-- <a-button @click="handlerTestClick(record, column)"> 测试</a-button>  @change="handleInputChange(record,column.dataIndex)"-->
            </template>
            <span slot="operation" slot-scope="{ record, text }">
              <a @click="handleOperation(text,record)" class="ml10">{{ text.quantity }}</a>
            </span>
          </ls-api-table>
        </a-spin>
      </div>
    </template>
  </ls-table-layout>
</template>

  <script>
  import { generateLsTableResData } from '@/utils/util.js';
  import { ApiSopMpProductionDemand } from '@/api/scp/month-plan/month-plan.js'

  export default {
    // eslint-disable-next-line
    name: 'detail', // name要和菜单路由保存一致; 新页面不要建这种容易重复的name
    components: {
    },
    data () {
      return {
        supplyTypeOptions: [],
        productBroadCategoryOpinions: [],
        isLoading: false,
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(ApiSopMpProductionDemand, true),
          pageCurrent: true
        },
        isEdit: false,
        currentId: "",
        // 控制搜索展开
        advanced: true,
        // 查询参数
        queryParams: {
            isRetailFlag: '',
            id: undefined,
            monthPlanName: undefined,
            itemIdList: undefined,
            monthPlanVersion: undefined,
            supplyTypeList: undefined,
            productBroadCategoryList: undefined
        },
        // 表格多选
        selectedRowKeys: [],
        selectedRows: [],
        // 状态快码
        statusOptions: [
          {
            dictLabel: "有效",
            dictValue: "Y"
          },
          {
            dictLabel: "无效",
            dictValue: "N"
          }
        ],
        baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
        // 表格字段
        columns: [
        ],
        columnsServe: [],
      // 表格字段
        columnsNative: [
          {
            title: '物料编码',
            ellipsis: true,
            dataIndex: 'itemCode',
            width: 180,
            align: 'center'
          },
          {
            title: '供应类型',
            ellipsis: true,
            dataIndex: 'supplyType',
            width: 180,
            align: 'center'
          },
          {
            title: '安全库存类别',
            dataIndex: 'scpSinvClassify',
            width: 150,
            align: 'center'
          },
          {
            title: '规格描述',
            ellipsis: true,
            dataIndex: 'specification',
            width: 220,
            align: 'center'
          },
          {
            title: '一件代发',
            ellipsis: true,
            dataIndex: 'isRetailFlag',
            scopedSlots: { customRender: 'isRetailFlag' },
            width: 180,
            align: 'center'
          },
          {
            title: '工艺大类',
            ellipsis: true,
            dataIndex: 'productBroadCategory',
            width: 180,
            align: 'center'
          }
        ],
        uomClassOptions: [],
        unitOfMeasureList: [],
        unitOfMeasureListNew: []
      }
    },
    created () {
      this.queryParams.monthPlanName = this.$route.params.name; // 从路由参数中获取 id 值
      this.queryParams.monthPlanVersion = this.$route.params.version; // 从路由参数中获取 id 值
      this.queryParams.id = this.$route.params.id; // 从路由参数中获取 id 值
      this.getLookupList('SCP_PRODUCT_BROAD_CATEGORY', 'productBroadCategoryOpinions')
      this.getLookupList('SCP_FG_SUPPLY_TYPE', 'supplyTypeOptions')
    },
    mounted () {
      this.onSearch()
    },
    methods: {
      statusOnChange () {
        this.queryParams.isRetailFlag = this.queryParams.isRetailFlag === 'Y' ? 'N' : 'Y'
    },
      getLookupList (type, arr) {
          const lookupQueryParams = {
            lookupType: type,
            current: 1,
            pageSize: 100
          }
          this.getLookupListData(lookupQueryParams).then().then(response => {
            this[arr] = response.rows
          })
    },
      handleExportDetail () {
        if (!this.queryParams.monthPlanName) {
          this.$message.error('月度计划名称不能为空')
          return
       }
        this.download('scp/sopMpProductionDemand/exportDetail', {
          ...this.queryParams
        }, `月度计划-生产需求汇总_${new Date().getTime()}.xlsx`)
      },
      handleOperation (text, record) {
        this.$router.push({ path: `/shipmentForecastManagement/monthsDetail/${this.queryParams.monthPlanName}/${this.queryParams.monthPlanVersion}/${record.itemId}/${text.month}/${record.demandDepartment}` })
      },
      // 导入导出excel
      /** 导出按钮操作 */
      handleExport () {
        if (!this.queryParams.monthPlanName) {
          this.$message.error('发货预测名称和版本必须不能为空')
          return
       }
        this.download('scp/sopMpProductionDemand/exportOverall', {
          ...this.queryParams
        }, `月度计划-生产需求列表_${new Date().getTime()}.xlsx`)
      },
      // 取消
      handleCancel (record) {
        this.isEdit = false
        this.onSearch()
      },
    // 搜索框展开、收起
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      // 表单搜索
      onSearch () {
       // this.getListShipmentForecastSum()
       if (!this.queryParams.monthPlanName) {
        this.$message.error('月度计划名称不能为空')
          return
       }
        this.isEdit = false
        this.$refs.dataTable.searchParams = this.queryParams;
        // this.$refs.dataTable.getData();
        this.$refs.dataTable.myPagination.current = 1
        this.getTableInfo({ ...this.queryParams, pageSize: this.$refs.dataTable.myPagination.pageSize, pageNum: 1 })
       },
      /** 重置按钮操作 */
      resetQuery () {
        this.queryParams = {
          monthPlanName: undefined,
          isRetailFlag: 'N',
          itemIdList: undefined,
          supplyTypeList: undefined,
          monthPlanVersion: undefined,
          productBroadCategoryList: undefined,
          id: this.queryParams.id
        }
        // this.onSearch()
      },
    /**
     * 在table 某个列的字段后增加列
     * key：列的字段名称
     * columnList 列表的列
     * insertColumnList 插入的新列
     *  */
    setNewColumn (key, columnList, insertColumnList) {
      const newArray = [...columnList] // 创建新的数组，保持原始数据的不变
      const index = newArray.findIndex((item) => item.dataIndex === key) // 找到具有indexKey值为'kk'的对象的索引位置
      if (index !== -1) {
        newArray.splice(index + 1, 0, ...insertColumnList) // 在索引位置后面插入新数组
      }
      return newArray
    },
    getTableInfo (id) {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      ApiSopMpProductionDemand(id).then((response) => {
        this.isLoading = false
        if (response.code === 200) {
          this.tableList = response.rows
          this.tableList.forEach((obj, index) => {
            obj.id = index + 1 // 生成唯一的ID，可以使用索引值加上 1
          })
          this.$refs.dataTable.myDataSource = this.tableList
          const titles = response.title
          this.columnsServe = response.title
          // 生成新的对象数组，并为每个对象添加name属性
          const newArray = titles.map((title) => {
            return {
              title: title.indexName,
              dataIndex: title.indexKey,
              scopedSlots: { customRender: 'month' },
              width: 120,
              align: 'center'
            }
          })
          const dynamicColumn = this.setNewColumn('productBroadCategory', this.columnsNative, newArray)
          this.columns = dynamicColumn
          this.$refs.dataTable.myPagination.total = response.total
          this.$refs.dataTable.pageTotal = this.$refs.dataTable.getPageTotal(response.total, this.$refs.dataTable.myPagination.pageSize)
        } else {
          this.tableList = []
            this.$refs.dataTable.myDataSource = this.tableList
          this.$message.error(response.msg)
        }
      }).catch((error) => {
        this.isLoading = false
        // 处理 API 调用失败的情况
        console.error('API 调用失败: ', error);
      })
    }

    }
  }
  </script>

  <style scoped lang="less">
  .ml10{
    margin-left: 10px;
  }
  </style>
